module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/187.b6b5a2a1.png";